"use client";

import { AutocompleteInput } from "@/components/search/autocomplete-input";
import { useTalentSearchFilters } from "@/components/search/talent-search-filters-provider";
import type { AutocompleteResult } from "@/lib/api/types";
import {
  ClearChipsButton,
  FilterChip,
  FilterFieldContainer,
  FilterFieldContent,
  FilterFieldLabel,
} from "../shared";

export function FilterLanguagesSection() {
  const { filters, updateFilter } = useTalentSearchFilters();
  const languages = filters.languages ?? [];

  return (
    <>
      <FilterFieldContainer>
        <FilterFieldLabel>Languages</FilterFieldLabel>
        <FilterFieldContent>
          <AutocompleteInput
            variant="filter"
            field="languages"
            placeholder="Search..."
            showAllOnOpen
            onSelect={(result: AutocompleteResult) => {
              if (!languages.some((l) => l.text === result.value)) {
                updateFilter("languages", [...languages, { text: result.value, required: false }]);
              }
            }}
            onFreeText={(text: string) => {
              updateFilter("languages", [...languages, { text: text.toLowerCase(), required: false }]);
            }}
          />
        </FilterFieldContent>
      </FilterFieldContainer>
      {languages.length > 0 && (
        <div className="flex flex-wrap gap-1">
          {languages.map((lang, i) => {
            const excluded = lang.mode === "exclude";
            const required = lang.required ?? false;
            return (
              <FilterChip
                key={i}
                label={lang.text}
                excluded={excluded}
                required={required}
                onToggleExclude={() => {
                  const next = [...languages];
                  next[i] = { ...lang, mode: excluded ? "include" : "exclude" };
                  updateFilter("languages", next);
                }}
                onToggleRequired={() => {
                  const next = [...languages];
                  next[i] = { ...lang, required: !required };
                  updateFilter("languages", next);
                }}
                onRemove={() => updateFilter("languages", languages.filter((_, j) => j !== i))}
              />
            );
          })}
          <ClearChipsButton onClick={() => updateFilter("languages", undefined)} />
        </div>
      )}
    </>
  );
}
